export default __webpack_public_path__ + "static/media/sun.cd6648ba.svg";